import * as Yup from 'yup';
export function getPostInitialValues(prePopulateState) {
    return {
        state: prePopulateState?.state || '',
        city: prePopulateState?.city || '',
        mile: prePopulateState?.mile || '',
        size: prePopulateState?.size || '',
        grade: prePopulateState?.grade || '',
    };
}

const VALIDATION_SCHEMA = () => {
    let schemaAttributes
        schemaAttributes = {
            city: Yup.string().trim(),
            state: Yup.string().trim(),
        }
    return Yup.object().shape(schemaAttributes);
}

export { VALIDATION_SCHEMA };